import { RouteConfig } from 'vue-router';

import PageProductStocks from './PageProductStocks.vue';

export default {
  path: 'stock',
  name: 'product-stocks',
  component: PageProductStocks,
  meta: {
    title: 'Estoque',
  },
} as RouteConfig;
